/**
 *  @class
 *  @function TermsCheckbox
 *  The cart's terms checkbox (cart-terms.liquid), in the cart drawer and on
 *  the cart page. Until it is checked, the checkout button asks for it and
 *  the accelerated checkout (wallet) buttons beside it are inert, faded
 *  (shop/_cart-checkout.scss); a click on them asks for it too. Each cart
 *  redraw brings a new checkbox, so whether it was checked is kept here,
 *  per checkbox, for as long as the page is open.
 */
if (!customElements.get('terms-checkbox')) {
  const accepted = new Set();

  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      if (!this.terms_checkbox) return;
      this.checkout_button = this.parentNode.querySelector('.button.checkout-button');
      this.wallets = this.parentNode.querySelector('.additional-checkout-buttons');
      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      if (accepted.has(this.append)) this.terms_checkbox.checked = true;
      this.terms_checkbox.addEventListener('change', () => this.update(), { signal });
      this.update();

      this.checkout_button?.addEventListener('click', (e) => {
        if (!this.terms_checkbox.checked) {
          this.ask();
          e.preventDefault();
        }
      }, { signal });

      // An inert element takes no clicks: one on the wallet buttons lands
      // on what is around them.
      this.parentNode.addEventListener('click', (e) => {
        if (!this.wallets?.inert) return;
        const box = this.wallets.getBoundingClientRect();
        if (e.clientX >= box.left && e.clientX <= box.right && e.clientY >= box.top && e.clientY <= box.bottom) this.ask();
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    update() {
      const checked = this.terms_checkbox.checked;
      if (checked) {
        accepted.add(this.append);
      } else {
        accepted.delete(this.append);
      }
      this.wallets?.toggleAttribute('inert', !checked);
    }

    ask() {
      this.terms_checkbox.reportValidity();
      this.terms_checkbox.focus();
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}
